import React from "react";
import ResourceListPage from "components/ResourceListPage";

const Publishers = () => (
  <ResourceListPage resource="publishers" title="Publishers" />
);

export default Publishers;
